import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'

import { ToogleCard } from '../ToogleCard'

const Mandatory = () => {
  const { associatedTaskItem: item, form, setInitialFormValue } = useFormProvider()

  useUnsafeEffect(() => {
    setInitialFormValue({
      mandatory: item?.mandatory !== undefined ? item?.mandatory : true,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ToogleCard
      title={i18n.t('processes.process_settings.wizard.tasks.form.mandatory')}
      tooltip={i18n.t('processes.process_settings.tasks.form.mandatory_desc')}
      tooglerValue={form.get('mandatory').value}
      onChange={(value: boolean) => form.setValues({ mandatory: value })}
    />
  )
}

export default Mandatory
